export enum DilutedSharesTitleWrapperBlock {
  Root = 'DilutedSharesTitleWrapper',
}

export enum DilutedSharesTitleWrapperElement {
  Content = 'content',
}
